import { sendEvent } from '@/methods/ga'

const URL = `http://d9rta2w5alo3er7n.mikecrm.com/vRlSgCC`

const feedbackMixin = {
    methods: {
        feedback () {
            sendEvent('home:click:feedback')
            window.location = URL
        }
    }
}

export default feedbackMixin



// WEBPACK FOOTER //
// ./src/mixins/feedback.js